<template>
  <div class="main-page-component">
    <div
      id="overlay"
      :class="{ visible: overlayVisible }"
      @click="onOverlayClick"
    >
      <ContactsForm ref="contact-form" />
    </div>

    <transition-group
      class="toast-overlay"
      name="toast"
      tag="div"
      appear
    >
      <div
        v-for="toast in toasts"
        :key="'toast_' + toast.id"
        class="toast"
        @click="removeToastById(toast.id)"
      >
        <VIcon
          class="close-icon"
          material="close"
        />

        <template v-if="toast.type === 'success'">
          <header>Заявка отправлена</header>
          <p>
            {{ toast.name }}, благодарим за ваш интерес!<br>
            Администратор свяжется с вами в ближайшее время.
          </p>
        </template>
        <template v-if="toast.type === 'error'">
          <header>Произошла ошибка</header>
          <p>Мы уже работаем над ней</p>
        </template>
      </div>
    </transition-group>

    <div
      id="mobile-menu-overlay"
      :class="{ active: mobileMenuVisible }"
      @click="onMobileMenuOverlayClick"
    >
      <div class="mobile-menu">
        <div class="header">
          ООО «Сибвалео Форин Трэйд»
        </div>

        <div class="logo">
          <svg
            width="211"
            height="41"
            viewBox="0 0 211 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M41.582 12.5181C39.0082 12.5181 36.982 13.2848 35.5035 14.8181C34.0432 16.3514 33.313 18.4141 33.313 21.0061C33.313 23.6164 34.0706 25.6882 35.5856 27.2215C37.1189 28.7365 39.1816 29.4941 41.7736 29.4941C43.3982 29.4941 44.8859 29.1929 46.2367 28.5905V21.1156H39.3094V19.3633H48.345V29.7679C46.2823 30.7718 44.028 31.2738 41.582 31.2738C38.4058 31.2738 35.8594 30.3429 33.9428 28.481C32.0444 26.6191 31.0952 24.1275 31.0952 21.0061C31.0952 17.8847 32.0262 15.3931 33.888 13.5312C35.7499 11.6693 38.2598 10.7384 41.4177 10.7384C43.7359 10.7384 45.7986 11.286 47.6057 12.3812L46.8664 13.9967C45.2236 13.011 43.4621 12.5181 41.582 12.5181ZM68.336 28.481C66.5653 30.3429 64.2106 31.2738 61.2718 31.2738C58.3329 31.2738 55.9691 30.3429 54.1802 28.481C52.3914 26.6009 51.4969 24.1092 51.4969 21.0061C51.4969 17.903 52.3914 15.4205 54.1802 13.5586C55.9691 11.6785 58.3329 10.7384 61.2718 10.7384C64.2106 10.7384 66.5653 11.6785 68.336 13.5586C70.1248 15.4205 71.0192 17.903 71.0192 21.0061C71.0192 24.1092 70.1248 26.6009 68.336 28.481ZM61.2718 29.4393C63.5352 29.4393 65.3515 28.6818 66.7205 27.1667C68.1078 25.6334 68.8014 23.5799 68.8014 21.0061C68.8014 18.4323 68.1078 16.3879 66.7205 14.8729C65.3515 13.3396 63.5352 12.5729 61.2718 12.5729C58.9901 12.5729 57.1556 13.3396 55.7683 14.8729C54.3993 16.3879 53.7147 18.4323 53.7147 21.0061C53.7147 23.5799 54.3993 25.6334 55.7683 27.1667C57.1556 28.6818 58.9901 29.4393 61.2718 29.4393ZM72.6602 11.0122H87.254V12.8741H81.066V31H78.8755V12.8741H72.6602V11.0122ZM91.5067 31V27.1667H94.0531V31H91.5067ZM98.9872 31V11.0122H101.205L108.324 23.0596H108.379L115.498 11.0122H117.798V31H115.607V14.6812H115.552L109.364 25.0584H107.338L101.15 14.6812H101.095V31H98.9872ZM121.095 31L128.405 11.0122H130.87L138.153 31H135.826L133.799 25.1679H125.366L123.367 31H121.095ZM125.969 23.4156H133.197L129.61 12.9836H129.555L125.969 23.4156ZM141.448 31V11.1491C143.036 10.8753 144.743 10.7384 146.569 10.7384C149.124 10.7384 151.05 11.213 152.346 12.1622C153.66 13.0931 154.317 14.4257 154.317 16.1598C154.317 17.547 153.943 18.7061 153.195 19.6371C152.446 20.568 151.388 21.2069 150.019 21.5537V21.6085C150.84 22.0466 151.652 23.2331 152.455 25.1679L154.865 31H152.592L150.238 25.2227C149.69 23.9084 149.17 23.0962 148.677 22.7858C148.202 22.4573 147.253 22.293 145.829 22.293H143.639V31H141.448ZM143.639 20.5406H145.829C148.001 20.5406 149.599 20.1938 150.621 19.5002C151.643 18.7883 152.154 17.7387 152.154 16.3514C152.154 13.7959 150.228 12.5181 146.377 12.5181C145.409 12.5181 144.497 12.6003 143.639 12.7646V20.5406ZM160.618 11.0122V19.9109H160.673L169.544 11.0122H172.2L162.589 20.5954L172.474 31H169.845L160.673 21.2525H160.618V31H158.428V11.0122H160.618ZM177.945 12.8467V19.3633H186.898V21.1156H177.945V29.1655H187.446V31H175.754V11.0122H187.446V12.8467H177.945ZM191.14 11.0122H205.734V12.8741H199.546V31H197.355V12.8741H191.14V11.0122Z"
              fill="#ffffff"
            />
            <rect
              x="0.555556"
              y="8.55556"
              width="10"
              height="10"
              stroke="#1281A3"
              stroke-width="1.11111"
            />
            <rect
              x="14.4442"
              y="8.55556"
              width="10"
              height="10"
              stroke="#F6AD58"
              stroke-width="1.11111"
            />
            <rect
              x="14.4442"
              y="22.4444"
              width="10"
              height="10"
              stroke="#30AD63"
              stroke-width="1.11111"
            />
            <circle
              cx="5.55556"
              cy="27.4444"
              r="5"
              stroke="#8F12A3"
              stroke-width="1.11111"
            />
            <line
              x1="5.55556"
              y1="8.55556"
              x2="5.55555"
              y2="18.5556"
              stroke="#1281A3"
              stroke-width="1.11111"
            />
          </svg>

          <button
            class="close-mobile-menu"
            @click="closeMobileMenu"
          >
            <i class="material-icons">close</i>
          </button>
        </div>

        <nav class="menu">
          <a
            href="#know-how"
            @click="smoothScroll"
          >
						Как это работет
					</a>

          <a
            href="#contacts"
            @click="smoothScroll"
          >
						Контакты
					</a>
        </nav>
      </div>
    </div>

    <section class="main-wrapper">
      <MainHeader />

      <SectionWelcomeTitle />

      <SectionPartners />

      <SectionStats />

      <SectionKnowHow id="know-how" />

      <SectionAction id="action" />

      <MainFooter id="contacts" />
    </section>
  </div>
</template>

<style lang="scss" src="./MainPage.scss"/>

<script lang="ts">
import ContactsForm        from './components/ContactsForm/ContactsForm.vue';
import MainHeader          from './components/MainHeader/MainHeader.vue';
import SectionWelcomeTitle from './components/SectionWelcomeTitle/SectionWelcomeTitle.vue';
import SectionPartners     from './components/SectionPartners/SectionPartners.vue';
import SectionStats        from './components/SectionStats/SectionStats.vue';
import SectionKnowHow      from './components/SectionKnowHow/SectionKnowHow.vue';
import SectionAction       from './components/SectionAction/SectionAction.vue';
import MainFooter          from './components/MainFooter/MainFooter.vue';
import VIcon 						   from "@/lib/components/VIcon/VIcon.vue";
import CookiePanel 						   from "@/pages/common/MainPage/components/CookiePanel/CookiePanel.vue";

export default defineComponent({
	name:       'MainPage',
	components: {
		ContactsForm,
		MainHeader,
		SectionWelcomeTitle,
		SectionPartners,
		SectionStats,
		SectionKnowHow,
		SectionAction,
		MainFooter,
		VIcon,
		CookiePanel
	},

	data() {
		return {};
	},

	computed: {
		overlayVisible() {
			return this.$store.getters['landing/overlayVisible'];
		},
		mobileMenuVisible() {
			return this.$store.getters['landing/mobileMenuVisible'];
		},
		toasts() {
			return this.$store.getters['landing/getToasts'];
		},
	},

	methods: {
		onOverlayClick(event) {
			if (event.target.id === 'overlay') {
				this.$refs['contact-form'].onClose();
			}
		},
		onMobileMenuOverlayClick(event) {
			if (event.target.id === 'mobile-menu-overlay') {
				this.closeMobileMenu();
			}
		},
		closeMobileMenu() {
			this.$store.dispatch('landing/toggleMobileMenu', false);
		},
		smoothScroll() {
			this.closeMobileMenu();
		},
		removeToastById(toastId) {
			this.$store.dispatch('landing/removeToast', toastId);
		},
	},
});
</script>
